import useLocalStorage from 'beautiful-react-hooks/useLocalStorage'
import { useMemo } from 'react'
import { LocalStorageKeys } from './types'

const translateSelectedTabIndexToActiveTab = (
  index: number,
  orderedTabs: string[]
): string => {
  if (index < 0 || index >= orderedTabs.length) {
    return orderedTabs[0]
  }
  return orderedTabs[index]
}

const translateActiveTabToSelectedTabIndex = (
  selectedTab: string | null,
  orderedTabs: string[]
): number => {
  if (selectedTab === null) {
    return 0
  }

  const selectedIndex = orderedTabs.findIndex((tab) => tab === selectedTab)
  if (selectedIndex < 0) {
    return 0
  }
  return selectedIndex
}

interface UseSelectedSubTabArgObject {
  localStorageKey: LocalStorageKeys
  orderedTabs: string[]
  tabChangeCallback?: () => void
}

interface UseSelectedSubTabReturnObject {
  onTabChange: (newTab: number) => void
  selectedIndex: number
}

type UseSelectedSubTab = (
  arg: UseSelectedSubTabArgObject
) => UseSelectedSubTabReturnObject

export const useSelectedSubTab: UseSelectedSubTab = ({
  localStorageKey,
  orderedTabs,
  tabChangeCallback,
}) => {
  const [activeTab, setActiveTab] = useLocalStorage<string>(
    localStorageKey,
    orderedTabs[0]
  )

  const onTabChange: (newTab: number) => void = (newTab) => {
    setActiveTab(() =>
      translateSelectedTabIndexToActiveTab(newTab, orderedTabs)
    )
    if (tabChangeCallback !== undefined) tabChangeCallback()
  }

  const selectedIndex = useMemo<number>(
    () => translateActiveTabToSelectedTabIndex(activeTab, orderedTabs),
    [activeTab, orderedTabs]
  )

  return {
    onTabChange,
    selectedIndex,
  }
}
